var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "position-relative h-100 w-100",
      class: { "dark-mode": _vm.users.darkMode, "new-theme": _vm.newTheme },
      attrs: { id: "app" },
    },
    [
      _vm.site && _vm.site.enable === false ? _c("SuspendComponent") : _vm._e(),
      _vm._v(" "),
      _vm.isLoggedIn && _vm.isSettingInitialized
        ? _c("WhatsappV3WarningBanner")
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoggedIn && _vm.isSettingInitialized
        ? _c("UnpaidInvoiceBanner")
        : _vm._e(),
      _vm._v(" "),
      !_vm.suspendModalVisible && _vm.shouldSelectPlanEnabled
        ? _c("LimitedModal", {
            on: {
              cancel: function ($event) {
                _vm.shouldSelectPlanEnabled = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.CONFIG.FEATURES.HEYSUPSIS_ENABLED ? _c("HeySupsis") : _vm._e(),
      _vm._v(" "),
      _vm.visitorDetailPopup
        ? _c("VisitorDetailPopup", { attrs: { visibleMail: false } })
        : _vm._e(),
      _vm._v(" "),
      _vm.whatsappImportState && _vm.whatsappImportState.status === "processing"
        ? _c("WhatsappImportStatusViewer", {
            attrs: { state: _vm.whatsappImportState },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("WindowManager"),
      _vm._v(" "),
      _vm.isLoggedIn &&
      _vm.isSiteSetupCompleted() &&
      !_vm.isNeededShowResetPasswordModal()
        ? _c("NewsModal")
        : _vm._e(),
      _vm._v(" "),
      _vm.site != null && _vm.site._id != null ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      !_vm.isGuideTutorialsCompleted() && !_vm.isNeededShowResetPasswordModal()
        ? _c("SetupWizard", {
            attrs: {
              lobbyData: _vm.site.lobbyData,
              createdDate: _vm.site.createdAt,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "multiSessionClass",
          attrs: {
            closable: false,
            footer: null,
            visible: _vm.multiSessionMode && _vm.isLoggedIn,
            centered: "",
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-column py-4" },
            [
              _c("p", { staticStyle: { "font-size": "20px" } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.multiModeAlertDesc")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "align-self-center",
                  attrs: { size: "large", type: "primary" },
                  on: { click: _vm.reloadPage },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.useHereText")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isSiteSetupCompleted()
        ? _c(
            "a-modal",
            {
              staticClass: "multiSessionClass",
              attrs: {
                closable: false,
                footer: null,
                title: _vm.$t("message.resetPassword"),
                visible:
                  _vm.isNeededShowResetPasswordModal() &&
                  !_vm.isSiteSetupCompleted(),
              },
            },
            [_c("ResetPassword", { attrs: { "on-completed": _vm.$_.noop } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("EmailValidationModal"),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          staticClass: "multiSessionClass",
          attrs: {
            closable: false,
            footer: null,
            visible: _vm.userRoleUpdated && _vm.isLoggedIn,
            centered: "",
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex flex-column py-4" },
            [
              _c("p", { staticStyle: { "font-size": "20px" } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("message.userRoleChanged")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c(
                "a-button",
                {
                  staticClass: "align-self-center",
                  attrs: { size: "large", type: "primary" },
                  on: { click: _vm.forceToMainPath },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("message.toMainPath")) +
                      "\n            "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      !_vm.isSiteSetupCompleted()
        ? _c(
            "a-modal",
            {
              staticClass: "fastWizardModal",
              style: { width: "100%", height: "100%", margin: 0 },
              attrs: {
                id: "fastWizardModal",
                closable: false,
                footer: null,
                title: null,
                visible: !_vm.isSiteSetupCompleted(),
              },
            },
            [_c("FastWizardV2")],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.videoCallMode ? _c("VideoCallScreen") : _vm._e(),
      _vm._v(" "),
      _c("OffLine", { staticClass: "h-100 w-100" }),
      _vm._v(" "),
      _vm.isLoggedIn && _vm.settings.privateChatEnabled && !_vm.isAdmin
        ? _c("UserChatChannelSideBar")
        : _vm._e(),
      _vm._v(" "),
      _c("ExternalWidgetViewer", {
        attrs: {
          title: _vm.widget.title,
          url: _vm.widget.url,
          visible: _vm.widget.visible,
          fullScreen: _vm.widget.fullScreen,
          mode: _vm.widget.mode,
          html: _vm.widget.html,
        },
        on: { close: _vm.handleWidgetClose },
      }),
      _vm._v(" "),
      _c("KeepAliveWidgetManager"),
      _vm._v(" "),
      _vm.isSettingInitialized &&
      !!_vm.user &&
      _vm.webphoneKirmiziSantralChannelExists
        ? _c("WebPhoneRedSantral")
        : _vm._e(),
      _vm._v(" "),
      _vm.isSettingInitialized && !!_vm.user && _vm.webphoneNetgsmChannelExists
        ? _c("WebPhoneNetGSM")
        : _vm._e(),
      _vm._v(" "),
      _vm.isSettingInitialized && !!_vm.user && _vm.webphoneTelnyxChannelExists
        ? _vm._l(_vm.userTelnyxChannels, function (channel) {
            return _c("WebphoneTelnyx", {
              key: "telnyx-" + channel._id,
              attrs: { "channel-id": channel._id },
            })
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.$store.state.app.postitBoardVisible
        ? _c("PostitBoard", {
            on: {
              close: function ($event) {
                return _vm.$store.commit("app/SET_POSTIT_BOARD_VISIBLE", false)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("InitialMessageModal"),
      _vm._v(" "),
      _c("SmartHoverActions"),
      _vm._v(" "),
      _c("WelcomeTransition"),
      _vm._v(" "),
      _c("NewYearSnowfall"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }